import { Injectable, inject } from '@angular/core';
import { AppService, GetFaqResponseDto } from '@src/api';
import { BehaviorSubject, catchError, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FaqService {
  private readonly api = inject(AppService);

  faqData$ = new BehaviorSubject<GetFaqResponseDto | undefined>(undefined);

  getFaq() {
    this.api
      .getFaq()
      .pipe(
        catchError(err => {
          return throwError(() => err);
        }),
      )
      .subscribe(data => {
        this.faqData$.next(data);
      });
  }
}
